import { IStoreState } from 'state/rootReducer';

export const getLink = ({ paymentSlipLink }: IStoreState): string =>
  paymentSlipLink.url;
